
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/terms-and-conditions/[slug]",
      function () {
        return require("private-next-pages/legal/terms-and-conditions/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/terms-and-conditions/[slug]"])
      });
    }
  